/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал получения хешированной информации о пользователе для авторизации в омничате.
 * Цель: сделать сервис хеширования информации для авторизации в омничате
 */

/**
 * Сервис для работы с омничатом
 */
export class OmnichatServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения хешированной инормации о пользователе.
   * Метод доступен для: master, employee
   * @deprecated
   */
  GetAuth = (req?: GetAuthRequestDto, init?: RequestInit): Promise<GetAuthResponseDto> => {
    return fm.request<GetAuthRequestDto, GetAuthResponseDto>(`${this.host}/omnichat/api/v1/auth${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Захешированные данные о пользователе
 */
export type AuthRequestDto = {
  /**
   * Закодированные клиентские данные
   */
  struct: string
  /**
   * Сгенерированный hash
   */
  hash: string
}
/**
 * Захешированные данные о пользователе
 */
export type AuthResponseDto = {
  /**
   * Закодированные клиентские данные
   */
  struct: string
  /**
   * Сгенерированный hash
   */
  hash: string
}
/**
 * Запрос получения списка хешированной информации о пользователе
 */
export type GetAuthRequestDto = {
}
/**
 * Ответ на запрос получения хешированной информации о пользователе
 */
export type GetAuthResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Омничат
   */
  readonly data: AuthResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Захешированные данные о пользователе
   */
  "Auth": {
    "kind": "class",
    "text": "Захешированные данные о пользователе",
    "fields": {
      /**
       * Закодированные клиентские данные
       */
      "struct": {
        "type": "string",
        "text": "Закодированные клиентские данные",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Сгенерированный hash
       */
      "hash": {
        "type": "string",
        "text": "Сгенерированный hash",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос получения списка хешированной информации о пользователе
   */
  "GetAuthRequest": {
    "kind": "class",
    "text": "Запрос получения списка хешированной информации о пользователе",
  },
  /**
   * Ответ на запрос получения хешированной информации о пользователе
   */
  "GetAuthResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения хешированной информации о пользователе",
    "fields": {
      /**
       * Омничат
       */
      "data": {
        "type": "Auth",
        "text": "Омничат",
      },
    },
  },
}